/* ==========================================================================
   Célon Atelier Customizer — core engine
   --------------------------------------------------------------------------
   Vanilla JavaScript, geen externe libraries, één globale: window.CelonCustomizer.

   ONTWERPPRINCIPE — ÉÉN SOURCE OF TRUTH
   Er is precies één state-object per customizer:

       { variantId, finish, count, slots: [charmId | null, ...] }

   Elke mutatie loopt via setState() -> normalize() -> render().
   render() is de ENIGE plek die DOM schrijft, en bouwt de hidden inputs elke
   keer volledig opnieuw op uit state.slots. Daardoor is de situatie
   "interface toont 4, Shopify ontvangt 2" structureel onmogelijk.

   Het aantal charms en de finish worden NIET door dit script bepaald, maar
   afgelezen van de gekozen Shopify-variant. De variant is de baas.
   ========================================================================== */

(function () {
  'use strict';

  var instances = [];
  var BOOTED = false;

  /* ---------------------------------------------------------------- utils */

  function qs(el, sel) { return el.querySelector(sel); }
  function qsa(el, sel) { return Array.prototype.slice.call(el.querySelectorAll(sel)); }

  function clamp(n, min, max) {
    n = parseInt(n, 10);
    if (isNaN(n)) return min;
    return Math.min(Math.max(n, min), max);
  }

  function fill(tpl, n) {
    return String(tpl == null ? '' : tpl).replace(/\{n\}/g, n);
  }

  function pad2(n) { return (n < 10 ? '0' : '') + n; }

  /* ------------------------------------------------------------ constructor */

  function Customizer(root) {
    this.root = root;

    var configEl = qs(root, '[data-cz-config]');
    if (!configEl) throw new Error('config ontbreekt');
    this.config = JSON.parse(configEl.textContent);

    var cfg = this.config;

    /* --- catalogus indexeren --- */
    this.byId = {};
    (cfg.catalog.charms || []).forEach(function (c) { this.byId[c.id] = c; }, this);

    /* --- productconfiguratie afleiden uit de blockinstellingen --- */
    this.deriveConfig();

    /* --- varianten indexeren --- */
    this.variants = {};
    (cfg.variants || []).forEach(function (v) { this.variants[String(v.id)] = v; }, this);

    /* --- DOM --- */
    this.slotEls    = qsa(root, '[data-cz-slot]');
    this.previewEls = qsa(root, '[data-cz-preview-item]');
    this.errorEl    = qs(root, '[data-cz-error]');
    this.finishEl   = qs(root, '[data-cz-preview-finish]');
    this.captionEl  = qs(root, '[data-cz-preview-caption]');

    /* --- formulier --- */
    this.form = (cfg.formId && document.getElementById(cfg.formId)) ||
                root.closest('form[action*="/cart/add"]') ||
                document.querySelector('form[action*="/cart/add"]');

    if (!this.form) throw new Error('product form niet gevonden');

    /* Hidden inputs leven IN het formulier, zodat theme.js ze bij het
       serialiseren automatisch meeneemt. We voegen alleen onze eigen
       container toe; aan de rest van het formulier veranderen we niets. */
    this.inputsEl = document.createElement('div');
    this.inputsEl.setAttribute('data-cz-inputs', cfg.uid);
    this.inputsEl.hidden = true;
    this.form.appendChild(this.inputsEl);

    this.variantSelect = this.form.querySelector('select[name="id"], input[name="id"]');

    /* --- drawer verplaatsen naar <body> zodat overflow/stacking van het
           theme hem nooit kan afknippen --- */
    this.drawer = qs(root, '[data-cz-drawer]');
    if (this.drawer) document.body.appendChild(this.drawer);

    /* --- state --- */
    this.state = {
      variantId: null,
      finish: cfg.defaultFinish,
      count: cfg.maxSelections,
      slots: []
    };

    this.activeSlot = null;
    this.lastFocus = null;
    this.frame = null;

    this.buildDrawer();
    this.restore();
    this.bind();
    this.syncFromVariant(true);
  }

  /* ------------------------------------------------------ productconfig

     Vertaalt de vrije tekstvelden uit de theme editor naar werkbare data.
     Dit is de enige plek waar productinstellingen worden geinterpreteerd;
     de rest van de engine werkt met het resultaat.                        */

  Customizer.prototype.deriveConfig = function () {
    var cfg = this.config;

    /* Terugvalwaarden. Teksten met {n} of {c} kunnen niet als Liquid-default
       geschreven worden (accolades botsen met de Liquid-parser), dus die
       vangen we hier af als de merchant het veld leeg laat. */
    var S = cfg.strings || (cfg.strings = {});
    function fallback(obj, key, value) {
      if (obj[key] === undefined || obj[key] === null || obj[key] === '') obj[key] = value;
    }

    fallback(cfg, 'propertyLabel', 'Charm {n}');
    fallback(S, 'placeholder', 'Choose your charm');
    fallback(S, 'drawerTitle', 'Select charm {n}');
    fallback(S, 'triggerAria', 'Charm {n}');
    fallback(S, 'nothingSelected', 'nothing selected yet');
    fallback(S, 'required', 'Please make a choice');
    fallback(S, 'errorSlot', 'Charm {n} has not been chosen yet.');
    fallback(S, 'errorVariant', 'Please choose a finish and a number of charms first.');
    fallback(S, 'errorIntegrity', 'Something went wrong with your composition. Please reload the page and try again.');
    fallback(S, 'previewProgress', '{c} of {n} chosen');
    fallback(S, 'empty', 'No charms available for this piece.');

    /* Finish: "Gold:gold, Silver:silver" -> { Gold: 'gold', Silver: 'silver' } */
    cfg.finishMap = {};
    cfg.finishValues = [];
    String(cfg.finishPairs || '').split(',').forEach(function (pair) {
      var bits = pair.split(':');
      if (bits.length !== 2) return;
      var label = bits[0].trim();
      var slug = bits[1].trim().toLowerCase();
      if (!label || !slug) return;
      cfg.finishMap[label] = slug;
      if (cfg.finishValues.indexOf(slug) === -1) cfg.finishValues.push(slug);
    });

    if (!cfg.finishValues.length) cfg.finishValues = ['gold'];
    cfg.defaultFinish = cfg.finishValues[0];

    /* Toegestane charms: expliciete whitelist wint, anders alle charms uit
       de toegestane categorieen, anders de hele catalogus. */
    var cats = String(cfg.categoryIds || '').split(',').filter(Boolean);
    var ids  = String(cfg.charmIds || '').split(',').filter(Boolean);

    this.allowed = {};
    this.allowedList = [];

    (cfg.catalog.charms || []).forEach(function (c) {
      var ok;
      if (ids.length) ok = ids.indexOf(c.id) > -1;
      else if (cats.length) ok = cats.indexOf(c.cat) > -1;
      else ok = true;
      if (ok) { this.allowed[c.id] = true; this.allowedList.push(c); }
    }, this);

    /* Categorieen in catalogusvolgorde, alleen die daadwerkelijk gevuld zijn */
    this.groups = (cfg.catalog.categories || []).map(function (cat) {
      return {
        id: cat.id,
        label: cat.label,
        charms: this.allowedList.filter(function (c) { return c.cat === cat.id; })
      };
    }, this).filter(function (g) { return g.charms.length > 0; });
  };

  /* -------------------------------------------------- drawer-inhoud bouwen

     Eenmalig bij initialisatie. Alle keuzes staan daarna in de HTML: het
     openen van de drawer kost geen network request en geen rendering.     */

  Customizer.prototype.buildDrawer = function () {
    if (!this.drawer) return;
    var body = qs(this.drawer, '[data-cz-drawer-body]');
    if (!body) return;

    if (!this.groups.length) {
      var empty = document.createElement('p');
      empty.className = 'celon-cz-drawer__empty';
      empty.textContent = this.config.strings.empty;
      body.appendChild(empty);
      return;
    }

    var frag = document.createDocumentFragment();

    this.groups.forEach(function (group) {
      var section = document.createElement('section');
      section.className = 'celon-cz-drawer__group';

      var title = document.createElement('h3');
      title.className = 'celon-cz-drawer__group-title';
      title.textContent = group.label;
      section.appendChild(title);

      var list = document.createElement('ul');
      list.className = 'celon-cz-drawer__grid';

      group.charms.forEach(function (charm) {
        var li = document.createElement('li');

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'celon-cz-drawer__option';
        btn.setAttribute('data-cz-option', charm.id);
        btn.setAttribute('aria-pressed', 'false');

        var media = document.createElement('span');
        media.className = 'celon-cz-drawer__option-media';

        var img = document.createElement('img');
        img.className = 'celon-cz__img';
        img.setAttribute('data-cz-img', '');
        img.setAttribute('loading', 'lazy');
        img.setAttribute('width', '46');
        img.setAttribute('height', '46');
        img.alt = '';
        img.hidden = true;

        var ph = document.createElement('span');
        ph.className = 'celon-cz__ph';
        ph.setAttribute('data-cz-ph', '');

        media.appendChild(img);
        media.appendChild(ph);

        var label = document.createElement('span');
        label.className = 'celon-cz-drawer__option-label';
        label.textContent = charm.label;

        btn.appendChild(media);
        btn.appendChild(label);

        if (charm.sub) {
          var sub = document.createElement('span');
          sub.className = 'celon-cz-drawer__option-sub';
          sub.textContent = charm.sub;
          btn.appendChild(sub);
        }

        li.appendChild(btn);
        list.appendChild(li);
      });

      section.appendChild(list);
      frag.appendChild(section);
    });

    body.appendChild(frag);
  };

  /* ------------------------------------------------------------- variant */

  Customizer.prototype.optionValue = function (variant, optionName) {
    if (!variant || !optionName) return null;
    var idx = this.config.optionNames.indexOf(optionName);
    if (idx === -1) return null;
    var val = variant.options[idx];
    return val == null ? null : String(val).trim();
  };

  Customizer.prototype.currentVariant = function () {
    if (!this.variantSelect) return null;
    return this.variants[String(this.variantSelect.value)] || null;
  };

  Customizer.prototype.syncFromVariant = function (initial) {
    var cfg = this.config;
    var v = this.currentVariant();

    var count = cfg.maxSelections;
    if (cfg.countOptionName) {
      var raw = this.optionValue(v, cfg.countOptionName);
      if (raw !== null) count = clamp(raw, 1, cfg.maxSelections);
      else if (!initial) count = this.state.count;
    }

    var finish = this.state.finish;
    if (cfg.finishOptionName) {
      var fraw = this.optionValue(v, cfg.finishOptionName);
      if (fraw !== null && cfg.finishMap[fraw]) finish = cfg.finishMap[fraw];
    }

    this.setState({
      variantId: v ? v.id : null,
      count: count,
      finish: finish
    });
  };

  /* --------------------------------------------------------------- state */

  Customizer.prototype.setState = function (patch) {
    var key;
    for (key in patch) {
      if (Object.prototype.hasOwnProperty.call(patch, key)) this.state[key] = patch[key];
    }
    this.normalize();
    this.render();
    this.persist();
  };

  /* Snijdt de state hard af op het gekozen aantal. Gaat de klant van 4 terug
     naar 2, dan houden charm 3 en 4 fysiek op te bestaan — niet verborgen,
     maar weg. Ongeldige of niet-toegestane ids worden hier ook opgeruimd. */
  Customizer.prototype.normalize = function () {
    var max = this.config.maxSelections;
    this.state.count = clamp(this.state.count, 1, max);

    var slots = this.state.slots.slice(0, this.state.count);
    while (slots.length < this.state.count) slots.push(null);

    for (var i = 0; i < slots.length; i++) {
      if (!slots[i] || !this.allowed[slots[i]]) slots[i] = null;
    }

    this.state.slots = slots;

    if (this.config.finishValues.indexOf(this.state.finish) === -1) {
      this.state.finish = this.config.defaultFinish;
    }
  };

  Customizer.prototype.reverseFinish = function (slug) {
    var map = this.config.finishMap, k;
    for (k in map) {
      if (Object.prototype.hasOwnProperty.call(map, k) && map[k] === slug) return k;
    }
    return null;
  };

  /* -------------------------------------------------------------- render */

  Customizer.prototype.render = function () {
    var self = this;
    var cfg = this.config;
    var st = this.state;

    /* 1 — slot-rijen */
    this.slotEls.forEach(function (el, i) {
      var visible = i < st.count;
      el.hidden = !visible;
      if (!visible) {
        self.clearSlotDom(el);
        return;
      }

      var charm = st.slots[i] ? self.byId[st.slots[i]] : null;
      var label = qs(el, '[data-cz-value]');
      var sub   = qs(el, '[data-cz-sub]');
      var trig  = qs(el, '[data-cz-trigger]');

      if (label) label.textContent = charm ? charm.label : fill(cfg.strings.placeholder, i + 1);
      if (sub) {
        sub.textContent = charm && charm.sub ? charm.sub : '';
        sub.hidden = !(charm && charm.sub);
      }
      el.classList.toggle('celon-cz__slot--empty', !charm);
      el.classList.remove('celon-cz__slot--invalid');

      var slotErr = qs(el, '[data-cz-slot-error]');
      if (slotErr) { slotErr.hidden = true; slotErr.textContent = ''; }

      if (trig) {
        trig.setAttribute('aria-label',
          fill(cfg.strings.triggerAria, i + 1) + ' — ' +
          (charm ? charm.label : cfg.strings.nothingSelected));
      }

      self.setMedia(qs(el, '[data-cz-img]'), qs(el, '[data-cz-ph]'), charm);
    });

    /* 2 — live preview */
    this.previewEls.forEach(function (el, i) {
      var visible = i < st.count;
      el.hidden = !visible;
      if (!visible) return;
      var charm = st.slots[i] ? self.byId[st.slots[i]] : null;
      self.setMedia(qs(el, '[data-cz-img]'), qs(el, '[data-cz-ph]'), charm);
    });

    if (this.finishEl) {
      this.finishEl.textContent = this.reverseFinish(st.finish) || '';
    }
    if (this.captionEl) {
      var chosen = st.slots.filter(Boolean).length;
      this.captionEl.textContent = chosen === st.count
        ? st.slots.map(function (id) { return self.byId[id].label; }).join('  ·  ')
        : fill(cfg.strings.previewProgress, st.count).replace('{c}', chosen);
    }

    /* 3 — hidden inputs: volledig opnieuw opgebouwd uit de state */
    this.renderInputs();

    /* 4 — drawer: media volgen de finish, selectie volgt de state */
    if (this.renderedFinish !== st.finish) {
      this.renderedFinish = st.finish;
      this.renderDrawerMedia();
    }
    if (this.drawer && this.drawer.classList.contains('is-open')) this.markDrawerSelection();

    /* 5 — assets van de andere finish alvast inladen */
    this.preloadOtherFinish();
  };

  /* De charm-afbeeldingen in de drawer volgen dezelfde finish als de preview.
     Wisselt de klant van Gold naar Silver, dan wisselt de hele drawer mee
     zonder dat er iets aan de selectie verandert. */
  Customizer.prototype.renderDrawerMedia = function () {
    if (!this.drawer) return;
    var self = this;
    qsa(this.drawer, '[data-cz-option]').forEach(function (btn) {
      var charm = self.byId[btn.getAttribute('data-cz-option')];
      if (!charm) return;
      self.setMedia(qs(btn, '[data-cz-img]'), qs(btn, '[data-cz-ph]'), charm);
    });
  };

  Customizer.prototype.clearSlotDom = function (el) {
    var label = qs(el, '[data-cz-value]');
    var sub = qs(el, '[data-cz-sub]');
    if (label) label.textContent = '';
    if (sub) { sub.textContent = ''; sub.hidden = true; }
    this.setMedia(qs(el, '[data-cz-img]'), qs(el, '[data-cz-ph]'), null);
  };

  Customizer.prototype.setMedia = function (img, ph, charm) {
    var cfg = this.config;
    var finish = this.state.finish;
    var src = charm && cfg.assetsReady && charm.img && charm.img[finish]
      ? cfg.assetBase + charm.img[finish]
      : null;

    if (img && src) {
      if (img.getAttribute('src') !== src) img.setAttribute('src', src);
      img.setAttribute('alt', charm.label);
      img.hidden = false;
      if (ph) ph.hidden = true;
      img.onerror = function () {
        img.hidden = true;
        if (ph) {
          ph.hidden = false;
          ph.textContent = charm.short || '';
          ph.setAttribute('data-finish', finish);
        }
      };
      return;
    }

    if (img) { img.hidden = true; img.removeAttribute('src'); }
    if (ph) {
      ph.hidden = false;
      ph.textContent = charm ? (charm.short || '') : '';
      ph.setAttribute('data-finish', finish);
      ph.classList.toggle('celon-cz__ph--empty', !charm);
    }
  };

  Customizer.prototype.preloadOtherFinish = function () {
    var cfg = this.config;
    if (!cfg.assetsReady) return;
    var other = cfg.finishValues.filter(function (f) { return f !== this.state.finish; }, this)[0];
    if (!other) return;
    this.state.slots.forEach(function (id) {
      var c = id && this.byId[id];
      if (c && c.img && c.img[other]) { var im = new Image(); im.src = cfg.assetBase + c.img[other]; }
    }, this);
  };

  /* De hidden inputs worden ELKE render weggegooid en opnieuw opgebouwd.
     Er kan dus nooit een input van een verwijderde charm blijven hangen. */
  Customizer.prototype.renderInputs = function () {
    var cfg = this.config;
    var st = this.state;

    while (this.inputsEl.firstChild) this.inputsEl.removeChild(this.inputsEl.firstChild);

    var ids = [];

    for (var i = 0; i < st.count; i++) {
      var id = st.slots[i];
      if (!id) continue;
      var charm = this.byId[id];
      if (!charm) continue;

      ids.push(id);

      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + fill(cfg.propertyLabel, i + 1) + ']';
      input.value = charm.label;
      input.setAttribute('data-cz-prop', String(i));
      this.inputsEl.appendChild(input);
    }

    if (ids.length) {
      this.inputsEl.appendChild(this.hidden('properties[_celon_charms]', ids.join('|')));
      this.inputsEl.appendChild(this.hidden('properties[_celon_finish]', st.finish));
      this.inputsEl.appendChild(this.hidden('properties[_celon_v]', String(cfg.catalog.version)));
    }
  };

  Customizer.prototype.hidden = function (name, value) {
    var el = document.createElement('input');
    el.type = 'hidden';
    el.name = name;
    el.value = value;
    return el;
  };

  /* ----------------------------------------------------------- validatie */

  Customizer.prototype.validate = function () {
    var cfg = this.config;
    var st = this.state;
    var errors = [];

    if (!this.currentVariant()) {
      errors.push({ message: cfg.strings.errorVariant });
    }

    for (var i = 0; i < st.count; i++) {
      if (!st.slots[i]) {
        errors.push({ slot: i, message: fill(cfg.strings.errorSlot, i + 1) });
      }
    }

    /* Fail-safe: tel wat er daadwerkelijk in het formulier staat. Wijkt dat af
       van de state, dan is er iets fundamenteel mis en gaat er niets naar de cart. */
    var actual = qsa(this.inputsEl, 'input[data-cz-prop]');
    var expected = st.slots.filter(Boolean).length;
    var tooHigh = actual.some(function (el) {
      return parseInt(el.getAttribute('data-cz-prop'), 10) >= st.count;
    });

    if (actual.length !== expected || tooHigh) {
      errors.push({ message: cfg.strings.errorIntegrity });
    }

    return errors;
  };

  Customizer.prototype.showErrors = function (errors) {
    var self = this;
    var messages = [];
    var firstSlot = null;

    errors.forEach(function (err) {
      if (typeof err.slot === 'number') {
        var el = self.slotEls[err.slot];
        if (el) {
          el.classList.add('celon-cz__slot--invalid');
          var se = qs(el, '[data-cz-slot-error]');
          if (se) { se.textContent = self.config.strings.required; se.hidden = false; }
          if (firstSlot === null) firstSlot = el;
        }
      }
      if (messages.indexOf(err.message) === -1) messages.push(err.message);
    });

    if (this.errorEl) {
      this.errorEl.textContent = messages.join(' ');
      this.errorEl.hidden = false;
    }

    var target = firstSlot || this.root;
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    var trig = firstSlot && qs(firstSlot, '[data-cz-trigger]');
    if (trig) { try { trig.focus({ preventScroll: true }); } catch (e) { trig.focus(); } }
  };

  Customizer.prototype.clearErrors = function () {
    if (this.errorEl) { this.errorEl.hidden = true; this.errorEl.textContent = ''; }
    this.slotEls.forEach(function (el) {
      el.classList.remove('celon-cz__slot--invalid');
      var se = qs(el, '[data-cz-slot-error]');
      if (se) { se.hidden = true; se.textContent = ''; }
    });
  };

  /* -------------------------------------------------------------- drawer */

  Customizer.prototype.openDrawer = function (index) {
    if (!this.drawer) return;
    this.activeSlot = index;
    this.lastFocus = document.activeElement;

    var title = qs(this.drawer, '[data-cz-drawer-title]');
    if (title) title.textContent = fill(this.config.strings.drawerTitle, pad2(index + 1));

    this.markDrawerSelection();

    var self = this;
    this.lockScroll();
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      self.drawer.classList.add('is-visible');
      var sel = qs(self.drawer, '[data-cz-option][aria-pressed="true"]');
      var focusTarget = sel || qs(self.drawer, '[data-cz-drawer-close]');
      if (focusTarget) {
        try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
      }
    });
  };

  Customizer.prototype.closeDrawer = function () {
    if (!this.drawer || !this.drawer.classList.contains('is-open')) return;
    var self = this;
    this.drawer.classList.remove('is-visible');
    this.unlockScroll();

    window.setTimeout(function () {
      self.drawer.classList.remove('is-open');
      self.drawer.setAttribute('aria-hidden', 'true');
      if (self.lastFocus && self.lastFocus.focus) {
        try { self.lastFocus.focus({ preventScroll: true }); } catch (e) { self.lastFocus.focus(); }
      }
      self.activeSlot = null;
    }, 260);
  };

  Customizer.prototype.markDrawerSelection = function () {
    if (!this.drawer) return;
    var current = this.activeSlot === null ? null : this.state.slots[this.activeSlot];
    qsa(this.drawer, '[data-cz-option]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-cz-option') === current ? 'true' : 'false');
    });
  };

  Customizer.prototype.lockScroll = function () {
    this.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.documentElement.classList.add('celon-cz-locked');
    document.body.style.top = (-this.scrollY) + 'px';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
  };

  Customizer.prototype.unlockScroll = function () {
    document.documentElement.classList.remove('celon-cz-locked');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, this.scrollY || 0);
  };

  Customizer.prototype.trapFocus = function (evt) {
    if (evt.key !== 'Tab') return;
    var focusables = qsa(this.drawer,
      'button:not([disabled]):not([hidden]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    ).filter(function (el) { return el.offsetParent !== null; });

    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    if (evt.shiftKey && document.activeElement === first) { evt.preventDefault(); last.focus(); }
    else if (!evt.shiftKey && document.activeElement === last) { evt.preventDefault(); first.focus(); }
  };

  /* ------------------------------------------------------------ selectie */

  Customizer.prototype.select = function (index, charmId) {
    if (index === null || index < 0 || index >= this.state.count) return;
    if (!this.allowed[charmId]) return;
    var slots = this.state.slots.slice();
    slots[index] = charmId;
    this.clearErrors();
    this.setState({ slots: slots });
  };

  /* --------------------------------------------------------- persistentie */

  Customizer.prototype.storageKey = function () {
    return 'celon-cz:' + this.config.productId;
  };

  Customizer.prototype.persist = function () {
    try {
      window.sessionStorage.setItem(this.storageKey(), JSON.stringify({
        v: this.config.catalog.version,
        slots: this.state.slots
      }));
    } catch (e) { /* private mode e.d. — persistentie is optioneel */ }
  };

  /* Herstelt eerdere keuzes na refresh of terugnavigeren. Alles wat hier
     binnenkomt gaat alsnog door normalize(), dus ongeldige of te veel
     opgeslagen keuzes worden gewoon weggegooid. */
  Customizer.prototype.restore = function () {
    try {
      var raw = window.sessionStorage.getItem(this.storageKey());
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || data.v !== this.config.catalog.version) return;
      if (Object.prototype.toString.call(data.slots) !== '[object Array]') return;
      this.state.slots = data.slots.slice(0, this.config.maxSelections);
    } catch (e) { /* negeren */ }
  };

  /* --------------------------------------------------------------- events */

  Customizer.prototype.bind = function () {
    var self = this;

    /* slot openen */
    this.slotEls.forEach(function (el, i) {
      var trig = qs(el, '[data-cz-trigger]');
      if (trig) trig.addEventListener('click', function (e) { e.preventDefault(); self.openDrawer(i); });
    });

    /* drawer */
    if (this.drawer) {
      qsa(this.drawer, '[data-cz-option]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          self.select(self.activeSlot, btn.getAttribute('data-cz-option'));
          self.closeDrawer();
        });
      });

      var closeBtn = qs(this.drawer, '[data-cz-drawer-close]');
      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); self.closeDrawer(); });

      var scrim = qs(this.drawer, '[data-cz-drawer-scrim]');
      if (scrim) scrim.addEventListener('click', function () { self.closeDrawer(); });

      this.drawer.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); self.closeDrawer(); return; }
        self.trapFocus(e);
      });
    }

    /* variantwijzigingen — het theme is en blijft de bron */
    var onVariant = function () {
      if (self.frame) cancelAnimationFrame(self.frame);
      self.frame = requestAnimationFrame(function () { self.syncFromVariant(); });
    };

    document.addEventListener('variant:change', onVariant);
    var container = this.root.closest('[data-section-id]');
    if (container) container.addEventListener('variantChange', onVariant);
    document.addEventListener('change', onVariant);
  };

  /* ---------------------------------------------------------- afbreken */

  Customizer.prototype.destroy = function () {
    if (this.drawer && this.drawer.parentNode) this.drawer.parentNode.removeChild(this.drawer);
    if (this.inputsEl && this.inputsEl.parentNode) this.inputsEl.parentNode.removeChild(this.inputsEl);
    var idx = instances.indexOf(this);
    if (idx > -1) instances.splice(idx, 1);
  };

  /* ------------------------------------------------------ submit-bewaking

     Capture-fase op document: deze listener vuurt gegarandeerd VOOR de
     submit-listener die theme.js op het formulier zelf zet. Er wordt geen
     regel theme-code aangepast. Formulieren zonder customizer worden meteen
     losgelaten.                                                            */

  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!form || form.nodeName !== 'FORM') return;

    var inst = null;
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].form === form) { inst = instances[i]; break; }
    }
    if (!inst) return;

    inst.render();                 // forceer een verse, consistente uitvoer
    var errors = inst.validate();
    if (!errors.length) { inst.clearErrors(); return; }

    evt.preventDefault();
    evt.stopPropagation();
    if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    inst.showErrors(errors);
  }, true);

  /* ------------------------------------------------------------- opstarten */

  function init(scope) {
    qsa(scope || document, '[data-celon-cz]').forEach(function (root) {
      if (root.getAttribute('data-cz-booted') === '1') return;
      root.setAttribute('data-cz-booted', '1');
      try {
        instances.push(new Customizer(root));
      } catch (e) {
        root.setAttribute('data-cz-booted', '0');
        if (window.console) console.error('[celon-customizer]', e);
      }
    });
  }

  function boot() {
    if (BOOTED) { init(); return; }
    BOOTED = true;
    init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme editor: sections worden opnieuw ingeladen */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    instances.slice().forEach(function (inst) {
      if (e.target.contains(inst.root)) inst.destroy();
    });
  });

  window.CelonCustomizer = { instances: instances, init: init };
})();
